import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronDownMedium"><Path d="M19.3105 9.5L12 16.8105L4.68945 9.5L5.75 8.43945L12 14.6895L18.25 8.43945L19.3105 9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDownMedium;
